import { useEffect, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCurrentTenant, type Branding } from "@/api/tenants";
import { useAuthStore } from "@/state/auth.store";
import { useBrandingStore } from "@/state/branding.store";

const DEFAULT_ACCENT = "#EF9F27";
const DEFAULT_ACCENT_DARK = "#BA7517";

/** Applies the current tenant's accent colours over the house-style tokens. */
export function BrandingProvider({ children }: { children: ReactNode }) {
  const tenantId = useAuthStore((s) => s.user?.tenant_id);
  const setBrandName = useBrandingStore((s) => s.setBrandName);

  const tenant = useQuery({
    queryKey: ["tenant-current"],
    queryFn: ({ signal }) => fetchCurrentTenant(signal),
    enabled: !!tenantId,
  });

  useEffect(() => {
    const root = document.documentElement;
    const branding: Branding = (tenantId && (tenant.data?.settings?.branding as Branding)) || {};
    root.style.setProperty("--amber", branding.accent || DEFAULT_ACCENT);
    root.style.setProperty("--amber-dark", branding.accent_dark || DEFAULT_ACCENT_DARK);
    setBrandName(tenantId ? branding.brand_name || null : null);
  }, [tenantId, tenant.data, setBrandName]);

  return <>{children}</>;
}
